import { createReducer, on } from '@ngrx/store';
import { setCoverages, updateCoverageStatus } from './coverages.actions';
import { ICoverageState } from './coverages.models';

export const initialState: ICoverageState = { list: [] };

export const coveragesReducers = createReducer(
    initialState,
    on(setCoverages, (state, { coverages }) => { return { ...state, list: coverages }}),
    on(updateCoverageStatus, (state, { id, status }) => {
        const newArray = state.list.map(x => JSON.parse(JSON.stringify(x)));
        const coverage = newArray.find(x => x.id === id);
        coverage.seleccionada = status.seleccionada;
        coverage.activada = status.activada;
        return { ...state, list: newArray };
    })
);